import React from "react";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt"; // Electric Grid
import BatteryFullIcon from "@mui/icons-material/BatteryFull"; // Battery
import PowerIcon from "@mui/icons-material/Power"; // Plug-In

const options = [
  { label: "On-Grid", systemType: 0, icon: <ElectricBoltIcon /> },
  { label: "Off-Grid", systemType: 1, icon: <BatteryFullIcon /> },
  { label: "Plug-In", systemType: 2, icon: <PowerIcon /> },
];

const SystemTypeChooseCard = ({ systemType, onSystemTypeChange }) => {
  return (
    <Card
      sx={{
        backgroundColor: "#28293e",
        mb: 3,
        px: { xs: 1.5, sm: 4 },
        py: { xs: 2, sm: 5 },
        width: "80%",
      }}
    >
      <CardContent>
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            color: "#fff",
            fontSize: { xs: "1rem", sm: "1.25rem" }, // Smaller font size for mobile
          }}
        >
          Choose system type
        </Typography>
        <Box
          sx={{
            paddingTop: { xs: "16px", md: "32px" },
            display: "flex",
            justifyContent: "space-evenly",
            gap: 4,
          }}
        >
          {options.map((option, idx) => (
            <Button
              onClick={() => onSystemTypeChange(option.systemType)}
              key={idx}
              variant="contained"
              sx={{
                display: "flex",
                backgroundColor: "#1c1c28",
                color: "#fff",
                flexDirection: "column",
                "&:hover": {
                  backgroundColor:
                    systemType === option.systemType ? "#3d3e52" : "#34344a",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
                },
                backgroundColor:
                  systemType === option.systemType ? "#ff6f61" : "#1c1c28", // Highlight selected option
              }}
            >
              <Box
                sx={{
                  fontSize: { xs: "2rem", sm: "2.5rem" }, // Adjust icon size
                }}
              >
                {React.cloneElement(option.icon, {
                  fontSize: "inherit", // Use the responsive font size
                })}
              </Box>
              <Typography
                variant="body2"
                sx={{
                  mt: 1,
                  fontSize: { xs: "0.75rem", sm: "0.875rem" }, // Smaller font size for mobile
                }}
              >
                {option.label}
              </Typography>
            </Button>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default SystemTypeChooseCard;
